import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { candidateManagementSlice } from "modules/candidates/_redux/candidateSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { loadUserByToken } from "modules/auth/_redux/authActions";
import { useEffect } from "react";

const candidateSliceActions = candidateManagementSlice.actions;

const nonAuthRoutes = ["/login", "/verify-email", "/reset-password", "/create-password", "/privacy-policy", "/terms-of-service"];

const AuthInit = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthorized, token, filtersForNextPreCandidate } = useSelector(
    ({ auth, candidateManagement }) => ({ isAuthorized: auth.isAuthorized, token: auth.token, filtersForNextPreCandidate: candidateManagement.filtersForNextPreCandidate }),
    shallowEqual
  );

  useEffect(() => {
    if (!location.pathname?.includes("/candidates/profile/") && filtersForNextPreCandidate) {
      dispatch(candidateSliceActions.setFiltersForNextPreCandidate(null));
    }

    if (!isAuthorized && token) {
      dispatch(loadUserByToken());
    } else if (!isAuthorized && !token && !nonAuthRoutes.includes(location.pathname)) {
      navigate("/login");
    } else if (isAuthorized && token && (nonAuthRoutes.includes(location.pathname) || location.pathname === "/")) {
      navigate("/dashboard");
    }
  }, [token, isAuthorized, location.pathname, dispatch, navigate]);

  return children;
};

export default AuthInit;
